import script from "./ContactMobile.vue?vue&type=script&setup=true&lang=ts"
export * from "./ContactMobile.vue?vue&type=script&setup=true&lang=ts"

import "./ContactMobile.vue?vue&type=style&index=0&id=1f2dc570&lang=scss&scoped=true"

import exportComponent from "/var/www/digital-card-solution-limited/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1f2dc570"]])

export default __exports__